// src/services/api/gamification.js
import apiClient from "./config";

// GET /api/gamification/dashboard
export async function getGamificationDashboard() {
  const { data } = await apiClient.get("/gamification/dashboard");
  return data;
}

// POST /api/gamification/claim
export async function claimGamificationReward(questId) {
  const { data } = await apiClient.post("/gamification/claim", { questId });
  return data;
}

// GET /api/gamification/leaderboard
export async function getGamificationLeaderboard() {
  const { data } = await apiClient.get("/gamification/leaderboard");
  return data;
}
